import './App.css';
import Header from './Navbar/Header';
import Home from './Home/Home';
import Footer from './Footer/Footer';
import Login from './Components/Authentication/Login';
import Register from './Components/Authentication/Register';
import MyAccount from './Pages/MyAccount';
import Booking from './Pages/Booking';
import EventOffer from './Pages/EventOffer';
import ContactUs from './Pages/ContactUs';
import About from './Pages/About';
import Wallet from './Pages/Wallet';
import Help from './Pages/Help';
import BookingHistory from './Pages/BookingHistory';
import AuthenticationHome from './Components/Authentication/AuthenticatioHome';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import NotFound from './Pages/NotFound';
import Level from './Pages/Level';
import AuthenticationHeader from './Components/Authentication/AuthenticationHeader';
import Deposit from './Components/walletModel/Deposit';
import Withrow from './Components/walletModel/Withrow';
import { useAuth } from './Service/Redux/AuthContext';
import DepositCrypto from './Components/walletModel/DepositCrypto';
import DepositFiat from './Components/walletModel/DepositFiat';
import { useState, useEffect, Suspense } from 'react';
import { BeatLoader } from 'react-spinners';

function App() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [location]);

  const PrivateRoute = ({ element }) => {
    return isAuthenticated ? element : <Navigate to="/login" />;
  };

  const AuthenticatedRoute = ({ element }) => {
    return isAuthenticated ? <Navigate to="/" /> : element;
  };

  return (
    <div className="App">
      {loading ? (
        <div className="loader-container">
          <BeatLoader loading={loading} size={18} />
        </div>
      ) : (
        <Suspense fallback={<BeatLoader loading={true} size={18} />}>
          {isAuthenticated ? <Header /> : <AuthenticationHeader />}

          <Routes>
            <Route path="/home" element={<AuthenticationHome />} />
            <Route path="/login" element={<AuthenticatedRoute element={<Login />} />} />
            <Route path="/register" element={<AuthenticatedRoute element={<Register />} />} />
            <Route path="/" element={isAuthenticated ? <Home /> : <Navigate to="/login" />} />
            <Route path="/account-details" element={<PrivateRoute element={<MyAccount />} />} />
            <Route path="/booking" element={<PrivateRoute element={<Booking />} />} />
            <Route path="/event" element={<PrivateRoute element={<EventOffer />} />} />
            <Route path="/customer-service" element={<PrivateRoute element={<ContactUs />} />} />
            <Route path="/about-us" element={<PrivateRoute element={<About />} />} />
            <Route path="/wallet" element={<PrivateRoute element={<Wallet />} />} />
            <Route path="/deposit" element={<PrivateRoute element={<Deposit />} />} />
            <Route path="/deposit-crypto" element={<PrivateRoute element={<DepositCrypto />} />} />
            <Route path="/deposit-fiat" element={<PrivateRoute element={<DepositFiat />} />} />
            <Route path="/booking-history" element={<PrivateRoute element= {<BookingHistory />} />} />
            <Route path="/help" element={<PrivateRoute element={<Help />} />} />
            <Route path="/level" element={<PrivateRoute element={<Level />} />} />
            <Route path="/widthrow" element={<PrivateRoute element={<Withrow />} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </Suspense>
      )}
    </div>
  );
}

export default App;
